import { useBonusContext } from '../../bonusContext';
import TimerBadge from '../../../../components/TimerBadge/TimerBadge';

function BonusTimeMobile() {
    const { bonusAvailableSecondsLeft } = useBonusContext();

    return <TimerBadge secondsLeft={bonusAvailableSecondsLeft}/>;
}

export default BonusTimeMobile;
